var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"}));
}

Chevron.defaultProps = {"width":"24","height":"24","className":"fill-current","viewBox":"0 0 24 24"};

module.exports = Chevron;

Chevron.default = Chevron;
